import { useState } from "react";
import { useSelector } from "react-redux";
import { isKIshaVisible, readKIshaOverride, KISHA_SURFACES } from "../utils/kishaVisibility";

// Bequemer Zugang zur Sichtbarkeitsregel aus kishaVisibility.js: holt sich den
// Zustand selbst, damit eine Aufrufstelle nur noch sagen muss, WO das Symbol
// sitzt - und nicht mehr, woraus sich die Entscheidung zusammensetzt.
export const useKIshaVisible = (surface = KISHA_SURFACES.INLINE) => {
  const agencyproperties = useSelector((state) => state.properties.agencyproperties);
  const selectedDestination = useSelector((state) => state.search.selectedDestination);
  const isIFrame = useSelector((state) => state.system.isIFrame);
  const isNativeApp = useSelector((state) => state.system.isNativeApp);

  // Einmal je Komponente gelesen. Der Schalter aendert sich nicht mitten in
  // einer Sitzung - wer ihn umlegt, laedt die Seite ohnehin neu.
  const [override] = useState(readKIshaOverride);

  return isKIshaVisible({ agencyproperties, selectedDestination, isIFrame, isNativeApp, surface, override });
};

export { KISHA_SURFACES };
